import React from 'react';
import Breadcrumbs from '../components/Breadcrumb';
import Stepper from '../components/hydrogen/Stepper';
import CommonBanner from '../components/CommonBanner';
import Banner from '../assets/images/green_banner.jpg';
import MoleculeValue from '../components/hydrogen/MoleculeValue';

const WhyHygen = () => {
  const breadcrumbItems = ['Hydrogen', 'Green Molecules'];

  return (
    <div>
      <div className='mt-16 sm:mt-20 md:mt-24 lg:mt-24 mx-6 sm:mx-8 md:mx-10 lg:mx-20'>
        <Breadcrumbs item1={breadcrumbItems[0]} item2={breadcrumbItems[1]} />
      </div>
      <div className="border-b border-gray-200 mt-2"></div>
      <div id="green-molecules">
        <CommonBanner 
          topTitle="Green Molecules"
          bannerImage={Banner}
          bannerImageAlt="Hydrogen Molecules Image"
          bannerTitle="The Future of Sustainable Energy"
          welcomeTitle="Green Molecules: A Vital Key to Decarbonization"
          welcomeDescription="Hydrogen, is a critical element in the fight against climate change. However, hydrogen is just 
          one example of a green molecule, a fuel created using renewable energy sources like solar or wind. These green 
          molecules hold immense potential for decarbonizing a variety of sectors, including transportation, industry, and 
          power generation. "
        />
        <Stepper />
      </div>
      <div id='why-green-molecules'>
        <MoleculeValue />
      </div>
    </div>
  )
}

export default WhyHygen;
